export default "__VITE_ASSET__DIF561Fv__"